/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Location_LabelInputs */



/**
* | output |
* | --- |
* | "Video Export Location:" |
*
* @param {Video_Export_Location_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_location_label = /** @type {((inputs?: Video_Export_Location_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Location_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Emplacement d'exportation video :")
	if (locale === "de") return /** @type {LocalizedString} */ ("Speicherort für den Videoexport:")
	if (locale === "it") return /** @type {LocalizedString} */ ("Posizione di esportazione video:")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Место экспорта видео:")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ubicación de exportación de video:")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("视频导出位置：")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ビデオのエクスポート場所:")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वीडियो निर्यात स्थान:")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Local de exportação do vídeo:")
	return /** @type {LocalizedString} */ ("Video Export Location:")
});